import { toast } from "react-toastify";

export function getTitle(title) {
  const splitedTitle = title?.split("||");
  return (
    <>
      <span>{splitedTitle?.[0]}</span>{" "}
      <span className="gray-font">{splitedTitle?.[1]}</span>
    </>
  );
}

export function getTitleWithBlueFont(title) {
  const splitedTitle = title.split("||");
  return (
    <>
      <span>{splitedTitle[0]}</span>{" "}
      <span className="blue-font">{splitedTitle[1]}</span>
    </>
  );
}

export function getImageUrl(path_name) {
  const splitedTitle = "";
  // const splitedTitle = "https://bluediamondvoyage.com/";
  const fullName = `${splitedTitle}${path_name}`.replaceAll('//', '/')
  return fullName;
}

// Toast notification functions
export const showToast = {
  success: (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  },
  error: (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  },
  info: (message) => {
    toast.info(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  },
  warning: (message) => {
    toast.warning(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  },
};
